import React from 'react';
import PropTypes from 'prop-types';

import HtmlElement from '../HtmlElement';

export const ButtonTypes = ['button', 'submit'];
export const ButtonDefaultType = 'button';

const defaultProps = {
  type: ButtonDefaultType,
  className: '',
  onClick: () => {},
  children: null,
};

const propTypes = {
  type: PropTypes.oneOf(ButtonTypes),
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

const Button = ({
  type,
  onClick,
  className,
  children,
}) => (
  <HtmlElement
    type={type}
    tagName="button"
    className={className}
    onClick={onClick}
  >
    {children}
  </HtmlElement>
);

Button.defaultProps = defaultProps;
Button.propTypes = propTypes;

export default Button;
